module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexbox"
  }, [_c('div', {
    staticClass: "flex-content"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-info btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("reset")])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-info btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.selectOption
    }
  }, [_vm._v("option select from parent")])]), _vm._v(" "), _c('div', [_c('model-select', {
    attrs: {
      "options": _vm.options,
      "placeholder": "placeholder text"
    },
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex-result"
  }, [_c('table', {
    staticClass: "ui celled table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.item))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("value")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b5a57e1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sample/Model/_NumberType.vue
// module id = 405
// module chunks = 2